import { FeatureFlag, useFeatureFlag } from 'shared';

export function useConstants(state?: string) {
    const { featureActive: isComplianceRefactorQualificationsActive } = useFeatureFlag(
        `COMPLIANCE_REFACTOR_QUALIFICATIONS_${state?.toUpperCase().replace(' ', '_') ?? 'OHIO'}` as FeatureFlag,
    );
    const DEGREE = isComplianceRefactorQualificationsActive ? 'Education' : 'Degree';
    const ECE_DEGREE = 'ECE-Related Degree';
    const PLACEHOLDER_HIGH_SCHOOL_CHOICE = isComplianceRefactorQualificationsActive
        ? null
        : { key: -1, value: 'High School' };
    const BASE_EDUCATION_OPTION_IDS = isComplianceRefactorQualificationsActive ? [-1, 0, null] : [-1, 0, 22, null];
    const CDA = isComplianceRefactorQualificationsActive ? 'CDA' : 'Child Development Associate (CDA) Credential';
    const YEARS_EXPERIENCE = isComplianceRefactorQualificationsActive
        ? 'Years Experience'
        : 'Years experience in a childcare center';
    const NEW_TO_CHILDCARE = { key: -1, value: 'New to Childcare (0-1 year)' };
    const NO_EDUCATION_REQUIRED_CHOICE = { key: -1, value: 'No Education Required' };

    const CLUMPED_YOE = [
        NEW_TO_CHILDCARE,
        { key: 1, value: 'Intermediate Experience (1-5 years)' },
        { key: 5, value: 'Very Experienced (5+ years)' },
    ];
    const valid_states_yoe_choices = VALID_STATES.map((state) => [state, CLUMPED_YOE]);
    const YOE_CHOICES_BY_STATE = {
        ...Object.fromEntries(valid_states_yoe_choices),
        [NORTH_CAROLINA]: CLUMPED_YOE.slice(1, 3),
    };

    const MINIMUM_WAGE_BY_STATE = {
        [OHIO]: 11,
        [FLORIDA]: 14,
        [ILLINOIS]: 15,
        [NORTH_CAROLINA]: 11,
    };

    // NOTE: Role (Lead Teacher or Assistant Teacher) qualification id
    const NORTH_CAROLINA_ROLE_ID = isComplianceRefactorQualificationsActive ? 67 : 98;

    const FLORIDA_45_HOURS_ID = isComplianceRefactorQualificationsActive ? 18 : 49;
    const FLORIDA_VPK_CREDENTIAL_ID = isComplianceRefactorQualificationsActive ? 26 : 51;
    const FLORIDA_STAFF_CREDENTIAL_ID = isComplianceRefactorQualificationsActive ? 27 : 52;
    const FLORIDA_DIRECTOR_CREDENTIAL_ID = isComplianceRefactorQualificationsActive ? 28 : 53;
    const FL_BOOLEAN_QUALIFICATION_PROBLEM_CHOICE_IDS = [
        FLORIDA_45_HOURS_ID,
        FLORIDA_VPK_CREDENTIAL_ID,
        FLORIDA_STAFF_CREDENTIAL_ID,
        FLORIDA_DIRECTOR_CREDENTIAL_ID,
    ];

    const STATE_SPECIFIC_REQUIREMENTS_TO_EXCLUDE = [NORTH_CAROLINA_ROLE_ID, FLORIDA_45_HOURS_ID];

    // NOTE: first aid/cpr
    const IL_BOOLEAN_QUALIFICATION_PROBLEM_CHOICE_IDS = isComplianceRefactorQualificationsActive ? [43, 46] : [84];

    // NOTE: cpl level
    const OH_SINGLE_QUALIFICATION_PROBLEM_CHOICE_IDS = isComplianceRefactorQualificationsActive ? [9] : [4];

    return {
        DEGREE,
        ECE_DEGREE,
        PLACEHOLDER_HIGH_SCHOOL_CHOICE,
        CDA,
        YEARS_EXPERIENCE,
        NEW_TO_CHILDCARE,
        NO_EDUCATION_REQUIRED_CHOICE,
        CLUMPED_YOE,
        valid_states_yoe_choices,
        YOE_CHOICES_BY_STATE,
        MINIMUM_WAGE_BY_STATE,
        NORTH_CAROLINA_ROLE_ID,
        FLORIDA_45_HOURS_ID,
        FLORIDA_VPK_CREDENTIAL_ID,
        FLORIDA_STAFF_CREDENTIAL_ID,
        FLORIDA_DIRECTOR_CREDENTIAL_ID,
        FL_BOOLEAN_QUALIFICATION_PROBLEM_CHOICE_IDS,
        IL_BOOLEAN_QUALIFICATION_PROBLEM_CHOICE_IDS,
        OH_SINGLE_QUALIFICATION_PROBLEM_CHOICE_IDS,
        STATE_SPECIFIC_REQUIREMENTS_TO_EXCLUDE,
        BASE_EDUCATION_OPTION_IDS,
    };
}

export const OHIO = 'Ohio';
export const FLORIDA = 'Florida';
export const ILLINOIS = 'Illinois';
export const NORTH_CAROLINA = 'North Carolina';
export const VALID_STATES = [ILLINOIS, OHIO, FLORIDA, NORTH_CAROLINA];

export const BOOL = 'BOOLEAN';
export const SINGLE = 'SINGLE_SELECT';
export const MULTI = 'MULTI_SELECT';

export const HIGH_SCHOOL = 'High School';
